import { BrandItemV2, BrandListRequestOption } from '../../../../../types/brand/list';
import BrandApiV2 from '../../../../../lib/api/brand/BrandApiV2';
import { SearchOption } from '../../../../../types/common/table';
import { WidgetBrandFilterOption } from '../../../../../types/widget';
import { BRAND_STATUS_V2 } from '../../../../../types/brand/common';
import { checkValidId } from '../../../../../lib/utils/common/checkValideId';

export const brandListFetcher = async (
  option: SearchOption<WidgetBrandFilterOption>,
): Promise<{ totalCount: number; list: BrandItemV2[] }> => {
  const defaultResult = {
    totalCount: 0,
    brands: [],
  };

  const result = checkValidId([option.id])
    ? await BrandApiV2.getBrandList(new BrandListRequestOption({ status: BRAND_STATUS_V2.ACTIVE, ...option }))
    : defaultResult;

  return {
    totalCount: result.totalCount,
    list: result.brands.map((brand) => new BrandItemV2(brand)),
  };
};
